import { gql } from 'graphql.macro';
export const messagesFragment = gql`
    fragment messagesFields on InternalChatMessage {
        _id
        originator
        originatorOrganization
        originatorName {
            firstName
            lastName
        }
        createdAt
        message
        type
        order
    }
`;

export const chatMessageFragment = gql`
    fragment chatMessage on ChatMessage {
        _id
        sender
        senderName
        senderOrganization
        message
        createdAt
        order
        isRead
    }
`;
